module.exports = __webpack_public_path__ + "media/images/img-eatout-2-ce879eae.jpg";